export const iconFontAwesomeDevicesHardwareDatabase = (
	<i className="fa-solid fa-database"></i>
);
